var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model from "@ember-data/model";
import { service } from "@ember/service";
import JournalEventModel from "core/models/journal-event";
import SemeiaSessionService from "core/services/session";
import Modifier from "ember-modifier";
const alertingStyleClassName = "alerting-style-class";
const alertingStyleClassNameBlack = "black";
let AlertingJeStyleModifier = (_class = class AlertingJeStyleModifier extends Modifier {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
  }
  modify(element, [journalEvent], {
    code,
    style
  }) {
    if (!this.session.medic) return;
    if (journalEvent?.isAlertingJournalEvent) {
      const isBioExam = journalEvent.constructor.modelName === "bio-exam-results-received-journal-event";
      const isBloodPressure = journalEvent.constructor.modelName === "blood-pressure-session-started-journal-event";

      // If it is a BioExamResult or a BloorPressure then we have to check for the corresponding code
      if (isBioExam && !journalEvent.hasAlertForCode(code)) return;
      if (isBloodPressure && !journalEvent.hasAlertForCode(code)) return;
      element.classList.add(alertingStyleClassName);
      if (style == "black") {
        element.classList.add(alertingStyleClassNameBlack);
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { AlertingJeStyleModifier as default };